<div class="parent-container">
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2 ">
      <img src="/assets/images/404-error.png" width="80px" height="80px" class="px-2 mx-2" alt="avatar" />
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
      <p class="m-b-0" style="font-size: 30px; font-weight: 500;">Page Not Found</p>
    </div>
    <p class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
      The page you are looking for can't be found
    </p>
    <p class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
      Try checking the URL or navigate to the previous page.
    </p>
  </div>
</div>